import { render, staticRenderFns } from "./RmcQuestionTile.vue?vue&type=template&id=26b4ffb4&scoped=true&"
import script from "./RmcQuestionTile.vue?vue&type=script&lang=js&"
export * from "./RmcQuestionTile.vue?vue&type=script&lang=js&"
import style0 from "./RmcQuestionTile.vue?vue&type=style&index=0&id=26b4ffb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b4ffb4",
  null
  
)

export default component.exports